import { useFormik } from 'formik';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import { manualAddressSchema } from './ManualAddressEntry.schema';
import { StructuredAddressFields } from './StructuredAddressFields';
import { toResolvedAddress } from './toResolvedAddress';
import type { ManualAddressEntryProps, ManualAddressValues } from './ManualAddressEntry.types';

const INITIAL_VALUES: ManualAddressValues = {
  streetNumber: '',
  unitNumber: '',
  streetName: '',
  city: '',
  state: null,
  postalCode: '',
};

/**
 * The fallback that keeps an order completable when the vendor lookup will not
 * answer. It emits the same `ResolvedAddress` a suggestion would, so nothing
 * downstream can tell the difference.
 */
const ManualAddressEntry = ({ onSubmit, isSubmitting }: ManualAddressEntryProps) => {
  const formik = useFormik<ManualAddressValues>({
    initialValues: INITIAL_VALUES,
    validationSchema: manualAddressSchema,
    onSubmit: (values) => onSubmit(toResolvedAddress(values)),
  });

  return (
    <Stack gap="15px">
      <StructuredAddressFields formik={formik} />
      <Button
        variant="checkAvailabilityCta"
        onClick={() => formik.handleSubmit()}
        disabled={isSubmitting}
        endIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : undefined}
      >
        {!isSubmitting ? 'Check Availability' : ''}
      </Button>
    </Stack>
  );
};

export default ManualAddressEntry;
